import { render, staticRenderFns } from "./ItemAttributeFilterNumericSelection.vue?vue&type=template&id=20248c1d&scoped=true"
import script from "./ItemAttributeFilterNumericSelection.vue?vue&type=script&lang=ts"
export * from "./ItemAttributeFilterNumericSelection.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttributeFilterNumericSelection.vue?vue&type=style&index=0&id=20248c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20248c1d",
  null
  
)

export default component.exports